import {Component, Injector, OnInit, Pipe, PipeTransform} from '@angular/core';
import {VideoCategoryInfoDto, VideoDto, VideoServiceProxy} from '../../../shared/service-proxies/service-proxies';
import {appModuleAnimation} from '../../../shared/animations/routerTransition';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.less'],
  animations: [appModuleAnimation()]
})

export class ListComponent implements OnInit {
  catId = Number(location.href.substr(location.href.indexOf('=') + 1));
  categorys: VideoCategoryInfoDto[] =  null;
  src: SafeResourceUrl;
  title: string;
  constructor(injector: Injector, private _videoService: VideoServiceProxy, private sanitizer: DomSanitizer) {
  }
  ngOnInit(): void {
   this._videoService.videoCategoryInfo(this.catId).subscribe((result) => {
        this.categorys = result;
        if (result.length > 0 &&  result[0].videos.length > 0) {
          this.title = result[0].videos[0].title;
          this.src = this.sanitizer.bypassSecurityTrustResourceUrl(result[0].videos[0].video);
          this._videoService.addViewTimes(result[0].videos[0].id).subscribe((bool) => {});
        }
    });
  }

  changeVideo(id: number): void {
    this._videoService.info(id).subscribe((result) => {
      this.title = result.title;
      this.src = this.sanitizer.bypassSecurityTrustResourceUrl(result.video);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/video/list/list.component.ts